import moment from 'moment';

const dateDiffInMonthsAndDays = (startDate, endDate) => {
  if (!startDate || !endDate) {
    return '-';
  }
  let start = moment(startDate).startOf('day');
  const end = moment(endDate).startOf('day').add(1, 'days');

  const years = end.diff(start, 'year');
  start.add(years, 'years');
  const months = end.diff(start, 'month');
  start.add(months, 'months');
  const days = end.diff(start, 'day');
  if (months + years < 1) {
    return getDays(days);
  }
  if (days === 0) {
    return getMonths(years * 12 + months);
  }
  return `${getMonths(years * 12 + months)} and ${getDays(days)}`;
};

const getDays = (days) => {
  if (days === 1) {
    return '1 day';
  }
  return `${days} days`;
};

const getMonths = (months) => {
  if (months === 1) {
    return '1 month';
  }
  return `${months} months`;
};

export default dateDiffInMonthsAndDays;
